import { Add, Remove } from "@mui/icons-material";
import { Button, ButtonGroup, Chip, useTheme } from "@mui/material";
import { useState } from "react";
import { User } from "../../app/backendTypes";
import CatalogAccessDialog from "./CatalogAccessDialog";
import { CatalogItem } from "../../app/backendTypes";

function CatalogBoardingAction(props: {
  disabled: boolean;
  onboarded: boolean;
  catalogItem: CatalogItem;
  user: User;
  callback: () => void;
}) {
  const { disabled, onboarded, catalogItem, user, callback } = props;

  const label = onboarded ? "Allowed" : "Blocked";
  const color = onboarded ? "success" : "error";
  const actionColor = onboarded ? "error" : "success";
  const actionIcon = onboarded ? <Remove /> : <Add />;

  const [open, setOpen] = useState(false);

  const theme = useTheme();

  return (
    <>
      <ButtonGroup size="small">
        <Chip
          variant="outlined"
          label={label}
          color={color}
          sx={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: 0,
          }}
        />
        <Button
          sx={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 20,
            borderBottomRightRadius: 20,
            borderLeftColor: theme.palette.divider,
          }}
          onClick={() => setOpen(true)}
          color={actionColor}
          disabled={disabled}
        >
          {actionIcon}
        </Button>
      </ButtonGroup>

      <CatalogAccessDialog
        onboarded={onboarded}
        open={open}
        setOpen={setOpen}
        catalogName={catalogItem.info.display_name}
        catalogId={catalogItem.id}
        user={user}
        callback={callback}
      />
    </>
  );
}

export default CatalogBoardingAction;
